import React, { useState } from 'react';

import { Stack, Button, Collapse, ChevronDownIcon } from '@metarouter-private/mr-mui';

import isActivePayloadCondition from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext/isActivePayloadCondition';

import PayloadConditionRow from './PayloadConditionRow';
import EventDebuggerAddPayloadFilterButton from './EventDebuggerAddPayloadFilterButton';
import PayloadFilterResultCount from './PayloadFilterResultCount';
import EventDebuggerAdvancedSearchTooltip from './EventDebuggerAdvancedSearchTooltip';
import usePayloadConditions from './usePayloadConditions';

export default function EventDebuggerAdvancedSearch() {
  const [expanded, setExpanded] = useState(false);
  const { payloadConditions } = usePayloadConditions();

  // Conditions keep filtering even when the panel is collapsed, so call out the active-filter count
  // on the toggle — otherwise a collapsed panel silently narrows results with no visible reason.
  const activeCount = payloadConditions.filter(isActivePayloadCondition).length;
  const filterNoun = activeCount === 1 ? 'Filter' : 'Filters';

  return (
    <Stack direction="column" pt={2}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          variant="text"
          color="secondary"
          size="small"
          startIcon={<ChevronDownIcon />}
          onClick={() => setExpanded(currentExpanded => !currentExpanded)}
          data-test-id="advancedSearchToggle"
        >
          Advanced Search
          {activeCount > 0 && <strong>{` (${activeCount} ${filterNoun} Currently Applied)`}</strong>}
        </Button>

        <EventDebuggerAdvancedSearchTooltip />
      </Stack>

      <Collapse in={expanded} unmountOnExit>
        <Stack pt={2} spacing={2}>
          {payloadConditions.map(condition => (
            <PayloadConditionRow key={condition.id} condition={condition} />
          ))}

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <EventDebuggerAddPayloadFilterButton />
            <PayloadFilterResultCount />
          </Stack>
        </Stack>
      </Collapse>
    </Stack>
  );
}
